import { render, staticRenderFns } from "./AltaModificacionProspecto.vue?vue&type=template&id=07c63ef4"
import script from "./AltaModificacionProspecto.vue?vue&type=script&lang=js"
export * from "./AltaModificacionProspecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports